<template>
    <div class="content">
        <div v-if="header">{{header}}</div>
        <div v-for="(item, j) in body" :key="j">
            <div class="title">{{item.title}}</div>
            <div class="cont" v-for="(i, k) in item.content" :key="k">
                <div>{{i}}</div>
            </div>
        </div>
        <div v-if="footer">{{footer}}</div>
    </div>
</template>

<script>
import { getQueryString } from "@/utils/utils";
export default {
    name: 'Pact',
    computed: {},
    data() {
        return {
            header: '',
            footer: '',
            body: ''
        }
    },
    mounted() {
        this.type = getQueryString("type") || "";
        this.getPact()
    },
    methods:{
        // 用户协议
        getPact() {
            let params = {
                type: this.type
            }
            this.$fetch({
                url: '/ehs/vms/protocol',
                method: 'post'
            }, params).then(res => {
                if(res.success) {
                    let { header, footer, body } = res.model;
                    this.header = header,
                    this.footer = footer,
                    this.body = body
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.content{
    width: 100vw;
    min-height: 100vh;
    font-size: 28px;
    padding: 20px;
    text-indent: 20px;
    line-height: 40px;
    box-sizing: border-box;
}

.title{
    padding: 20px 0;
}

.cont{
    padding: 10px 0; 
}
</style>